import { PatientsTagsEnum } from './types'

//   DOCTOR_APPOINTMENT_REQUEST_SENT = "Doctor Appointment Request Sent",

//   REPORT_SENT = "Report Sent",
export const getTagColor = (tag?: string) => {
  if (!tag) return

  switch (tag) {
    case PatientsTagsEnum.UNINVITED: {
      return '#ea0b5c'
    }
    case PatientsTagsEnum.WELCOMED: {
      return '#1565C0'
    }
    case PatientsTagsEnum.QUESTIONNAIRE_SENT: {
      return '#02BD85'
    }
    case PatientsTagsEnum.RESPONSE_RECEIVED: {
      return '#017c98'
    }
    case PatientsTagsEnum.NURSE_APPOINTMENT_REQUEST_SENT: {
      return '#832e02'
    }
    case PatientsTagsEnum.NURSE_APPOINTMENT_TAKEN: {
      return '#cf8e09'
    }
    case PatientsTagsEnum.DOCTOR_APPOINTMENT_REQUEST_SENT: {
      return '#510787'
    }
    case PatientsTagsEnum.DOCTOR_APPOINTMENT_TAKEN: {
      return '#8b42bf'
    }
    case PatientsTagsEnum.REPORT_SENT: {
      return '#14c503'
    }

    default: {
      return tag ? `#${(tag.split('').reduce((v, c) => 419 * (v + c.charCodeAt(0) * 2557), 0) % (256 * 256 * 256)).toString(16)}` : '#000000'
    }
  }
}
